import { render, staticRenderFns } from "./evaluacion-indicadores-consolidado.vue?vue&type=template&id=51f14222&"
import script from "./evaluacion-indicadores-consolidado.vue?vue&type=script&lang=js&"
export * from "./evaluacion-indicadores-consolidado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports